import { observer } from "mobx-react-lite";
import Markers from "./markers";
import { MapWrapper, MapWrapperProps } from "./map-wrapper";
import { MapMarker } from "../../../stores/map/types";

type MapProps = MapWrapperProps & {
    useAdvancedMarker?: boolean;
    markers: MapMarker[];
    markerImage?: string;
}

const Map = observer((props: MapProps) => {
    const {
        // styles,
        useAdvancedMarker = false,
        className = "map"
    } = props;

    const libraries = useAdvancedMarker ? ["places", "marker"] : ["places"];

    return (
        <MapWrapper {...props} className={className} libraries={libraries}>
            <Markers {...props} />
        </MapWrapper>
    );
});


export default Map;
